import Vue from 'vue';
import moment from 'moment';

import { httpMixin } from '@baseball-systems/http';
import { plotCalculatorMixin } from '@baseball-systems/plotCalculator';
import { colorsMixin } from '@baseball-systems/colors';
import Search from '@baseball-systems/MasterSearch';

import { getTruMediaHeatmapGradient } from 'library/static/baseGradients';

import { ModuleRegistry } from '@ag-grid-community/core';
import { ExcelExportModule } from '@ag-grid-enterprise/excel-export';
ModuleRegistry.registerModules([ExcelExportModule]);

const Modal = () => import('library/components/reusable/containers/Modal.vue');
const DvSection = () => import('library/components/reusable/containers/DvSection.vue');
const CividPlayer = () => import('library/components/videoPlayer/CividPlayer');
const PitchPlot = () => import('library/components/visuals/pitchPlot/PitchPlotNew');
const GameTypeOptions = () => import('library/components/reusable/GameTypeOptions/GameTypeOptions');

const ArsenalPitchUsageChart = () => import('../../../pdev/lib/Vue/arsenal/pitch_usage.vue');
const SideSessionsComponent = () => import('../../../pdev/lib/Vue/side_sessions/side_sessions');

const ModelDetails = () => import('./ModelDetails.vue');

const Assessments = () => import('../../../modules/reports/Assessments/Assessments.vue');
const HitterAssessments = () => import('../../../modules/reports/Assessments/HitterAssessments.vue');
const PitcherAssessments = () => import('../../../modules/reports/Assessments/PitcherAssessments.vue');
const CreateAssessments = () => import('../../../modules/reports/Assessments/CreateAssessments.vue');
const DefenseAssessments = () => import('../../../modules/reports/Assessments/DefenseAssessments.vue');
const BirdDog = () => import('../../../modules/reports/BirdDog/BirdDog.vue');
const ExternalLinksTable = () => import('../../../modules/reports/ExternalLinks/ExternalLinksTable.vue');

window.showModelDetails = function (playerPage, playerID, playerObj) {
  // if the vue does not exist, recreate it
  if (!playerPage.modelGridVue) {
    playerPage.modelGridVue = new Vue({
      el: '#model-details-vue-container',
      data: {
        playerID,
        playerObj,
      },
      render: (h) => h(ModelDetails),
    });
  }

  // normal DView player method of hiding / showing page content
  let $container = $('.print-statement'),
    $noRemove = $container.find('p.printHeader');

  $container.find('p.printHeader').empty().append('<strong>Model Details</strong>');
  $container.html($noRemove);
  $container.append('');

  $('#contentModelDetails').show();
};

window.ArsenalComponents = () => {
  return {
    pitchUsage: ArsenalPitchUsageChart,
    pitchplot: PitchPlot,
    plotCalculatorMixin: plotCalculatorMixin,
    colorsMixin: colorsMixin,
    getTruMediaHeatmapGradient,
  };
};

window.cividPlayer = CividPlayer;

window.showSideSessions = (playerPage, WahooId) => {
  if (!playerPage.sideSessionTable) {
    playerPage.sideSessionTable = new Vue({
      el: '#side-session-vue',
      render: (h) =>
        h(SideSessionsComponent, {
          props: {
            WahooId: WahooId,
            context: 'DV',
          },
        }),
    });
  }
};
// game type editor
window.GameTypeEditor = function (placeholder) {
  window.GameTypeEditorVue = new Vue({
    el: placeholder,
    components: {
      GameTypeOptions,
      Modal,
    },
    data: {
      showModal: false,
      gridKey: null,
    },
    methods: {
      handleUpdates(e) {
        this.parentClass.myOtherParams.GameTypes = e.serializedDefaults;
        this.parentClass.gameTypeOptions = e.defaults;
        this.parentClass.processClickedOptions();
        this.showModal = false;
      },
    },
    template: `<modal v-model="showModal" width="680px" max-width="100%" height="360px" overflow="auto" >
            <game-type-options 
                :gridKey="gridKey" 
                @cancel="showModal = false" 
                @update="handleUpdates"
            />
        </modal>
        `,
  });
};

//assessments
window.Assessments = function (obj, placeholder, appConstantData, theater = 'pro') {
  window.AssessmentsVue = new Vue({
    el: placeholder,
    components: {
      Assessments,
      Modal,
      HitterAssessments,
      PitcherAssessments,
      CreateAssessments,
      DvSection,
      DefenseAssessments,
    },
    mixins: [httpMixin],
    data: {
      player: obj,
      playerAssessments: { Rows: [] },
      theater,
      expandAll: false,
      showModal: false,
      showCreateModal: false,
      assessment: obj,
      isPitcher: false,
      createAssessment: false,
      newAssessment: { Authors: [] },
      assessType: null,
    },
    mounted() {
      this.getSetData();
    },
    methods: {
      closeHandler() {
        this.showModal = false;
        this.showCreateModal = false;
        this.getSetData();
      },
      getSetData() {
        if (appConstantData.Permissions.indexOf('CanAccessTonto') >= 0) {
          this.request(`/dvsvc/ScoutingAssessList?PlayerID=${this.player.PlayerID}`, 'GET').then((assessments) => {
            assessments.Rows = assessments.Rows.map((row) => {
              return {
                ...row,
                Expand: false,
              };
            }).sort(
              (a, b) =>
                a.AssessTypeId - b.AssessTypeId || a.Status - b.Status || moment(b.StartDt).subtract(moment(a.StartDt)),
            );

            assessments.showCreateButton = true;
            this.playerAssessments = assessments;
          });
        }
      },
      modalHandler(e) {
        this.assessment = e;
        this.createAssessment = false;
        this.showCreateModal = false;
        this.isPitcher = e.IsPitcher;
        this.assessType = e.AssessTypeId;
        this.showModal = e.closeModal ? false : true;
      },
      modalCreate(e) {
        this.createAssessment = false;
        if (e.AssessTypeId === 5) {
          const url = window.location.hostname === 'localhost' ? 'http://localhost:5173' : window.location.hostname === 'beta.indiansfrontoffice.com' ? 'https://dv.dev.bb.gcp.guardiansfrontoffice.com' : 'https://dv.bb.guardiansfrontoffice.com';
          window.open(`${url}/#/assessments/pitcher/${e.ReportID}?ispitcher=true&playerid=${e.PlayerID}`, '_blank', 'width=' + screen.width + ',height=' + screen.height + ',menubar=no,toolbar=no,location=no,status=no');
          this.showModal = false
          window.location.reload();
          return;
        }
        else if (e.AssessTypeId === 6) {
        const url = window.location.hostname === 'localhost' ? 'http://localhost:5173' : window.location.hostname === 'beta.indiansfrontoffice.com' ? 'https://dv.dev.bb.gcp.guardiansfrontoffice.com' : 'https://dv.bb.guardiansfrontoffice.com';
          window.open(`${url}/#/assessments/hitter/${e.ReportID}?playerid=${e.PlayerID}`, '_blank', 'width=' + screen.width + ',height=' + screen.height + ',menubar=no,toolbar=no,location=no,status=no');
          this.showModal = false
          window.location.reload();
          return;
        }
        else {
          this.modalHandler(e);
        }
      },
    },
    template: `<div id="dview-assessments">
                <dv-section id="assessments" title="Assessments" style="margin-bottom: 20px">
                    <assessments :propPlayer="player" :propShowCreateButton="true" :propAssessments="playerAssessments" :propExpandAll="expandAll" @modalOpened="modalHandler" @create="createAssessment=true; showCreateModal=true;" @delete="getSetData" ></assessments>
                    <modal v-if="showModal" v-model="showModal" :clickOutside="false" :margin="'20px auto auto'" width="100%" :maxWidth="'1200px'" :height="'calc(100% - 100px)'" overflow="auto" >
                        <template v-if="assessType === 0 && !createAssessment">    
                            <hitter-assessments :propPlayer="assessment" :propAssessments="playerAssessments" :theater="theater" @close="closeHandler"></hitter-assessments>
                        </template>
                        <template v-else-if="assessType === 1 && !createAssessment">    
                            <pitcher-assessments :propPlayer="assessment" :propAssessments="playerAssessments" :theater="theater" @close="closeHandler"></pitcher-assessments>
                        </template>
                        <template v-else-if="assessType > 1 && !createAssessment">    
                            <defense-assessments :propPlayer="assessment" :propAssessments="playerAssessments" :theater="theater" @close="closeHandler"></defense-assessments>
                        </template>
                    </modal>
                    <modal v-if="showCreateModal" v-model="showCreateModal" width="100%" :maxWidth="'600px'" overflow="auto" >
                        <template v-if="createAssessment">
                            <create-assessments :propPlayer="player" :propNewAssessment="newAssessment"  :propDefAsmtType="assessType" @modalOpened="modalCreate" @close="closeHandler"></create-assessments>
                        </template>
                    </modal>
                </dv-section>
            </div>
           `,
  });
};
window.HitterAssessments = (obj, theater = 'pro') => {
  const params = new URLSearchParams(window.location.search);
  //check if it's a first time load
  if (window.HitterAssessmentsVue) {
    window.HitterAssessmentsVue.player = obj;
    window.HitterAssessmentsVue.getSetData();
  } else {
    window.HitterAssessmentsVue = new Vue({
      el: '#hitter-assessments-placeholder',
      components: {
        HitterAssessments,
      },
      mixins: [httpMixin],
      data: {
        player: obj,
        playerAssessments: null,
        theater,
        close: false,
        isDirty: false,
      },
      mounted() {
        this.getSetData();
      },
      methods: {
        getSetData() {
          if (this.player !== null) {
            this.request(`/dvsvc/ScoutingAssessList?PlayerID=${this.player.Assess.PlayerID}`, 'GET').then(
              (assessments) => {
                assessments.Rows = assessments.Rows.sort((a, b) => moment(b.StartDt).subtract(moment(a.StartDt)));

                assessments.showCreateButton = true;
                this.playerAssessments = assessments;
                this.player.showCreateButton = true;
              },
            );
          }
        },
        closeHandler() {
          if (window.modal !== undefined) {
            window.modal.Vue.Close();
          } else {
            window.close();
          }
          this.getSetData();
        },
      },
      template:
        '<hitter-assessments :propPlayer="player" :propAssessments="playerAssessments" :propIsDirty="false" :theater="theater" @close="closeHandler"  ></hitter-assessments>',
    });
  }
};
window.PitcherAssessments = (obj, theater = 'pro') => {
  const params = new URLSearchParams(window.location.search);
  //check if it's a first time load
  if (window.PitcherAssessmentsVue) {
    window.PitcherAssessmentsVue.player = obj;
    window.PitcherAssessmentsVue.getSetData();
  } else {
    window.PitcherAssessmentsVue = new Vue({
      el: '#pitcher-assessments-placeholder',
      components: {
        PitcherAssessments,
      },
      mixins: [httpMixin],
      data: {
        player: obj,
        playerAssessments: obj,
        theater,
        close: false,
        isDirty: false,
      },
      mounted() {
        this.getSetData();
      },
      methods: {
        getSetData() {
          if (this.player !== null) {
            this.request(`/dvsvc/ScoutingAssessList?PlayerID=${this.player.Assess.PlayerID}`, 'GET').then(
              (assessments) => {
                assessments.Rows = assessments.Rows.sort((a, b) => moment(b.StartDt).subtract(moment(a.StartDt)));
                assessments.showCreateButton = true;
                this.playerAssessments = assessments;
                this.player.showCreateButton = true;
              },
            );
          }
        },
        closeHandler() {
          if (window.modal !== undefined) {
            window.modal.Vue.Close();
          } else {
            window.close();
          }
          this.getSetData();
        },
      },
      template:
        '<pitcher-assessments :propPlayer="player" :propAssessments="playerAssessments" :propIsDirty="false" :theater="theater" @close="closeHandler"  ></pitcher-assessments>',
    });
  }
};
window.CreateAssessments = (obj, asmtType) => {
  const params = new URLSearchParams(window.location.search);
  //check if it's a first time load
  if (window.CreateAssessmentsVue) {
    window.CreateAssessmentsVue.player = obj;
    window.CreateAssessmentsVue.getPlayer();
    window.CreateAssessmentsVue.defAsmtType = asmtType;
  } else {
    window.CreateAssessmentsVue = new Vue({
      el: '#create-assessments-placeholder',
      components: {
        CreateAssessments,
      },
      mixins: [httpMixin],
      data: {
        player: obj,
        newAssessment: { Authors: [] },
        defAsmtType: asmtType,
      },
      methods: {
        getPlayer() {
          this.request(`/dvsvc/NewScoutingAssess?PlayerID=${this.player.PlayerID}`, 'GET').then((resp) => {
            this.newAssessment = resp;
          });
        },
        mounted() {
          this.getPlayer();
        },
      },
      template: '<create-assessments :propPlayer="player" :propNewAssessment="newAssessment" ></create-assessments>',
    });
  }
};
window.DefenseAssessments = (obj, theater = 'pro', AsmtType) => {
  const params = new URLSearchParams(window.location.search);
  //check if it's a first time load
  if (window.DefenseAssessmentsVue) {
    window.DefenseAssessmentsVue.player = obj;
    window.DefenseAssessmentsVue.asmtType = AsmtType;
    window.DefenseAssessmentsVue.getSetData();
    window.DefenseAssessmentsVue.getAssessmentData();
  } else {
    window.DefenseAssessmentsVue = new Vue({
      el: '#defense-assessments-placeholder',
      components: {
        DefenseAssessments,
      },
      mixins: [httpMixin],
      data: {
        player: obj,
        playerAssessments: { Rows: [] },
        theater,
        close: false,
        isDirty: false,
        asmtType: null,
      },
      mounted() {
        this.getSetData();
        this.getAssessmentData();
      },
      methods: {
        getSetData() {
          if (this.player !== null) {
            let playerID = null;
            if (this.player.Assess !== null) {
              playerID = this.player.Assess.PlayerID;
            } else {
              playerID = this.player.PlayerID;
            }
            this.request(`/dvsvc/ScoutingAssessList?PlayerID=${playerID}`, 'GET').then((assessments) => {
              assessments.Rows = assessments.Rows.sort(
                (a, b) => a.AssessTypeId - b.AssessTypeId || moment(b.StartDt).subtract(moment(a.StartDt)),
              );
              this.playerAssessments = assessments;
            });
          }
        },
        getAssessmentData() {
          this.asmtType = AsmtType;
          if (this.player === null) return;
          if (this.player.Assess === undefined || this.player.Assess === null) {
            if (this.player.AssessTypeId === 2) {
              this.request(`/dvsvc/ScoutingAssessCatcherEditable?ReportID=${this.player.ReportID}`, 'GET').then(
                (assessment) => {
                  //update service to defense!
                  this.player = assessment;
                },
              );
            } else if (this.player.AssessTypeId === 3) {
              this.request(`/dvsvc/ScoutingAssessInfielderEditable?ReportID=${this.player.ReportID}`, 'GET').then(
                (assessment) => {
                  //update service to defense!
                  this.player = assessment;
                },
              );
            } else if (this.player.AssessTypeId === 4) {
              this.request(`/dvsvc/ScoutingAssessOutfielderEditable?ReportID=${this.player.ReportID}`, 'GET').then(
                (assessment) => {
                  //update service to defense!
                  this.player = assessment;
                },
              );
            }
          }
        },
        closeHandler() {
          if (window.modal !== undefined) {
            window.modal.Vue.Close();
          } else {
            window.close();
          }
          this.getSetData();
        },
      },
      template: `<defense-assessments :propPlayer="player" :propAssessments="playerAssessments" :propIsDirty="false" :theater="theater" :propAsmtType="asmtType" @close="closeHandler"  ></defense-assessments>`,
    });
  }
};
window.BirdDog = (obj) => {
  const params = new URLSearchParams(window.location.search);
  //check if it's a first time load
  window.BirdDogVue = new Vue({
    el: '#bird-dog',
    // :propBirdDogData="birdDogData"
    components: {
      BirdDog,
      DvSection,
    },
    mixins: [httpMixin],
    data: {
      player: obj,
    },
    mounted() {
      this.getPlayer();
    },
    methods: {
      getPlayer() {
        this.request(`/dvsvc/BirdDogHitterReports?PlayerID=${this.player.PlayerID}`, 'GET').then((resp) => {});
      },
    },
    template:
      ' <dv-section id="birddog" title="BirdDog" style="margin-bottom: 20px"><bird-dog :propPlayer="player"></bird-dog></dv-section>',
  });
};

window.ExternalLinksTable = (player) => {
  if (window.PlayerExternalLinksTableVue) {
    window.PlayerExternalLinksTableVue.player = player;
  } else {
    window.PlayerExternalLinksTableVue = new Vue({
      el: '#external-links-placeholder',
      components: {
        ExternalLinksTable,
        DvSection,
      },
      data() {
        return {
          player,
        };
      },
      template: `
      <div id='external-links-placeholder' class='tabContent'>
        <dv-section title='External links' style='margin-bottom: 20px'>
          <ExternalLinksTable :player='player' />
        </dv-section>
      </div>`,
    });
  }

  return window.PlayerExternalLinksTableVue;
};

window.vueComponents = () => {
  return {
    search: Search,
  };
};
